import {
  AfterContentInit,
  ContentChild,
  ContentChildren,
  Directive,
  Input,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, combineLatest, map, Observable, startWith } from 'rxjs';

import { SlotNodeData } from '@blaze-runtime/engine-domain';
import { isEqualNoUndefined } from '@blaze-shared/shared-util';

import { ComponentSlotData } from '../element-component';

import { RenderElementDirective } from './render-element.directive';
import { SlotMarkerDirective } from './slot-marker.directive';

@UntilDestroy()
@Directive({
  selector: '[blazeRenderElementHost]',
  standalone: false,
})
// TODO: test
export class RenderElementHostDirective implements AfterContentInit {
  @ContentChildren(SlotMarkerDirective, { read: TemplateRef }) templates?: QueryList<
    TemplateRef<unknown>
  >;
  @ContentChild(RenderElementDirective) renderElementDirective?: RenderElementDirective;

  private slotNodeData$ = new BehaviorSubject<SlotNodeData[]>([]);

  @Input() set blazeRenderElementHost(value: SlotNodeData[] | undefined) {
    if (!isEqualNoUndefined(this.slotNodeData$.value, value)) {
      this.slotNodeData$.next(value || []);
    }
  }

  ngAfterContentInit(): void {
    if (!this.templates || !this.renderElementDirective) {
      console.error('RenderElementHostDirective: missing child elements');
      return;
    }

    combineLatest({
      templates: this.templates.changes.pipe(startWith(this.templates)) as Observable<
        QueryList<TemplateRef<unknown>>
      >,
      slotNodeData: this.slotNodeData$,
    })
      .pipe(
        untilDestroyed(this),
        map(({ templates, slotNodeData }) => {
          const slotIds = slotNodeData.map((data) => data.slotId);
          const templatesArray = templates.toArray();
          return {
            slotIds,
            slotNodesData: slotIds.reduce(
              (acc, slotId, index) => ({ ...acc, [slotId]: slotNodeData[index] }),
              {},
            ),
            templates: slotIds.reduce(
              (acc, slotId, index) => ({ ...acc, [slotId]: templatesArray[index] }),
              {},
            ),
          } as ComponentSlotData;
        }),
      )
      .subscribe((slotData) => {
        this.renderElementDirective?.updateSlotData(slotData);
      });
  }
}
